export default "__VITE_ASSET__23a56df3__"